/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Inventory = "inventory",
    Plattegrond = "plattegrond",
    Notebook = "notebook",
    AchievementMenu = "achievementmenu",
    Sound = "sound",
};
